// TODO do we ever navigate here?
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const verUtil = require('../util/version.js');
const UriUtil = require('../util/UriUtil');
const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
import TopNav from './DashboardNew/Menu/TopNav';
import LoadingMainContent from './loading/LoadingMainContent';
import HelpDropdown from './nav/HelpDropdown';
import ConfirmModal from './modal/ConfirmModal';
import IFrame from './IFrame';
import WithActivityData from './DataHOCs/WithActivityData';
import WithChannelData from './DataHOCs/WithChannelData';
import WithProjectData from './DataHOCs/WithProjectData';
import WithTemplateData from './DataHOCs/WithTemplateData';
import WithDocumentVisible from './DataHOCs/WithDocumentVisible';
import WithActivityEditAccessData from './DataHOCs/WithActivityEditAccessData';
const VoiceStore = require('../stores/VoiceStore');
const ChatbotSystem = require('../util/ChatbotSystem');
import Navigator from '../Navigator';

const topLevelViewPropTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
            activityVersion: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
};

const topLevelViewDeafaultProps = {};

const baseComponentPropTypes = {
    history: PropTypes.object.isRequired,
    channelId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    activityId: PropTypes.string.isRequired,
    activityVersion: PropTypes.string,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
    channelStoreState: PropTypes.object.isRequired,
    activityStoreState: PropTypes.object.isRequired,
    projectStoreState: PropTypes.object.isRequired,
    templateStoreState: PropTypes.object.isRequired,   
};

const baseComponentDefaultProps = {};

//function PreviewActivityEditorComponent(props) {
    
class PreviewActivityEditorComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modalData: null
        }
    }
    
    _gotoEdit=()=>{
        const props = this.props;
        if (props.activityVersion) {
            if (verUtil.parseVersion(props.activityVersion).isAutosave()) {
                props.history.push(`/project/${props.channelId}/${props.projectId}/activity/${props.activityId}/edit/${props.activityVersion}`);
            }
            else {
                this.setState({
                    modalConfirm: {
                        modalTitle: "Confirm Edit Prior Version",
                        text: "Are you sure you wish to edit the previous version? Saving will bypass more recent changes.",
                        confirmHandler: ()=>{
                            this.setState({modalConfirm: null},()=>{
                                props.history.push(`/project/${props.channelId}/${props.projectId}/activity/${props.activityId}/edit/${props.activityVersion}`);
                            })
                        },
                        cancelHandler: ()=>{
                            this.setState({modalConfirm: null})
                        },

                    }
                });
                return;
            }
        }
        else {
            props.history.push(`/project/${props.channelId}/${props.projectId}/activity/${props.activityId}/edit`);
        }
    }
    
    render() {
        const props = this.props;
        let buttonText = 'Edit';
        if (props.activityVersion) {
            buttonText += ` v${props.activityVersion}`;
        }

        let modalConfirm;
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            modalConfirm = (
                <ConfirmModal key="modal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }

        return (
            <div className="preview-activity">
                <TopNav onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(null, props.history, props.channelId)}>
                    <HelpDropdown/>
                    {(PermissionsUtil.canEditActivity(props.channelStoreState.channel.user_permissions, props.projectStoreState.project.user_permissions)) &&
                        <Button className="editorButton" onClick={this._gotoEdit}>{buttonText}</Button>
                    }

                </TopNav>
                <WrappedPreviewView
                    {...props}
                    previewFrom={UriUtil.parseLocationSearchString(props.location).previewFrom}
                />
                {modalConfirm}
            </div>
        );
    } // render
} // PreviewActivityEditorComponent

PreviewActivityEditorComponent.propTypes = baseComponentPropTypes;
PreviewActivityEditorComponent.defaultProps = baseComponentDefaultProps;

const WrappedPreviewActivityEditorComponent = WithActivityData(WithTemplateData(WithChannelData(WithProjectData(PreviewActivityEditorComponent))));
WrappedPreviewActivityEditorComponent.propTypes = topLevelViewPropTypes;
WrappedPreviewActivityEditorComponent.defaultProps = topLevelViewDeafaultProps;
export function PreviewActivityEditorView(props) {
     return (
        <WrappedPreviewActivityEditorComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
            activityVersion={props.match.params.activityVersion}
        />
    );
}

function PreviewActivityReviewComponent(props) {
    function _gotoReview() {
        if (props.activityVersion) {
            // no confirm neccessary. review is read-only
            props.history.push(`/project/${props.channelId}/${props.projectId}/activity/${props.activityId}/review/${props.activityVersion}`);
        }
        else {
            props.history.push(`/project/${props.channelId}/${props.projectId}/activity/${props.activityId}/review`);
        }
    }

    let buttonText = 'Review';
    if (props.activityVersion) {
        buttonText += ` v${props.activityVersion}`;
    }

    return (
        <div className="preview-activity">
            <TopNav onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(null, props.history, props.channelId)}>
                <HelpDropdown/>
                {(PermissionsUtil.canReviewActivity(props.channelStoreState.channel.user_permissions, props.projectStoreState.project.user_permissions)) &&
                    <Button className="editorButton" onClick={_gotoReview}>{buttonText}</Button>
                }

            </TopNav>
            <WrappedPreviewView
                {...props}
                previewFrom={UriUtil.parseLocationSearchString(props.location).previewFrom}
            />
        </div>
    );
}
PreviewActivityReviewComponent.propTypes = baseComponentPropTypes;
PreviewActivityReviewComponent.defaultProps = baseComponentDefaultProps;

const WrappedPreviewActivityReviewComponent = WithActivityData(WithTemplateData(WithChannelData(WithProjectData(PreviewActivityReviewComponent))));
WrappedPreviewActivityReviewComponent.propTypes = topLevelViewPropTypes;
WrappedPreviewActivityReviewComponent.defaultProps = topLevelViewDeafaultProps;
export function PreviewActivityReviewView(props) {
     return (
        <WrappedPreviewActivityReviewComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
            activityVersion={props.match.params.activityVersion}
        />
    );
}



// PreviewView component -----------------------
const propTypes = {
    activityVersion: PropTypes.string,
    previewFrom: PropTypes.string,
    activityStoreState: PropTypes.shape({
        activity: PropTypes.shape({
            activity_id: PropTypes.string.isRequired
        })
    }).isRequired,
    templateStoreState: PropTypes.shape({
        template: PropTypes.shape({
            template_url: PropTypes.string.isRequired,
        }).isRequired
    }).isRequired,
    activityEditAccessInfo: PropTypes.shape({
        id: PropTypes.string.isRequired,
        access_key: PropTypes.string.isRequired,
        permissions: PropTypes.object.isRequired,
    }).isRequired,
};

const defaultProps = {
    activityVersion: '',
    previewFrom: '',
};

export class PreviewView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clientFeatures: null,
        };

        this.iframe = React.createRef();
        this.onClientFeatures = this.onClientFeatures.bind(this);
        this.sendUserData = this.sendUserData.bind(this);
        this._handlePreviewMessage = this._handlePreviewMessage.bind(this);
        const activity = props.activityStoreState && props.activityStoreState.activity;
        const userData = {...props.activityEditAccessInfo,
            activityId: activity ? activity.id : null,
            channelId: activity ? activity.owner_id : null,
        };
        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.ACTIVITY_PREVIEW,{userData});
        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.ACTIVITY_PREVIEW});
    }

    componentDidMount() {
        const self = this;
        $(window).off('message', this._handlePreviewMessage).on('message', this._handlePreviewMessage);
    }

    componentWillUnmount() {
        $(window).off('message', this._handlePreviewMessage);
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }
    }

    _handlePreviewMessage(e) {
        const msg = e.originalEvent.data;
        const origin = e.originalEvent.origin;
        console.debug('PREVIEW _handlePreviewMessage', origin, msg);

        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }

        const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;

        if (this.chatbotSystem) {
            let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
        }
        if (this.voiceSystem) {
            let handled = this.voiceSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
        }

        switch (msg.type) {
            case 'features': {// client telling forge what it can do
                this.onClientFeatures(msg.features);
                break;
            }
            case "request-user-data": {
                this.sendUserData();
                break;
            }
        }
    }

    onClientFeatures(features) {
        const self = this;
        this.setState({ clientFeatures: features }, () => {
            self.sendUserData();
        });
    }

    sendUserData() {
        if (this.state.clientFeatures.user_data) {
            const iframe = this.iframe.current;
            if (!!iframe) {
                iframe.contentWindow.postMessage({ type: 'user-data', user_data: this.props.activityEditAccessInfo }, '*');
            }
        }
    }

    render() {
        if (!this.props.templateStoreState.initialized || !this.props.activityStoreState.activity) {
            return (
                <div className="mzlIFrame--other">
                    <LoadingMainContent />
                </div>
            );
        }
        else {
            const _activity = this.props.activityStoreState.activity;
            const _template = this.props.templateStoreState.template;
            let versionSuffix = '';
            let queryString = '';
            if (this.props.activityVersion) {
                versionSuffix = `/${this.props.activityVersion}`;
            }

            if (this.props.previewFrom) {
                queryString = `?previewFrom=${encodeURIComponent(this.props.previewFrom)}`;
            }

            return (
                <IFrame
                    ref={this.iframe}
                    url={`${_template.template_url}/preview/web/${_activity.activity_id}${versionSuffix}${queryString}`}
                />
            );
        }
    }
}

PreviewView.propTypes = propTypes;
PreviewView.defaultProps = defaultProps;

const WrappedPreviewView = WithDocumentVisible(WithActivityEditAccessData(PreviewView));